import { render, staticRenderFns } from "./specialSetting.vue?vue&type=template&id=eb9dacd0&scoped=true"
import script from "./specialSetting.vue?vue&type=script&lang=js"
export * from "./specialSetting.vue?vue&type=script&lang=js"
import style0 from "./specialSetting.vue?vue&type=style&index=0&id=eb9dacd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb9dacd0",
  null
  
)

export default component.exports